export enum SaveStatus {
  unsaved = 'unsaved',
  saved = 'saved',
  saving = 'saving',
  no_file = 'NO_FILE',
}
